import React, { useMemo } from 'react';
import { Icon as TTIcon } from '@tt/ui';
import cx from 'classnames';
import PropTypes from 'prop-types';

import colors from '../../constants/colors';
import { Tooltip } from '../Tooltip';

import styles from './IconTooltip.module.scss';
let idCounter = 0;
const useTooltipId = () => {
  const id = useMemo(() => idCounter++, []);
  return `tooltip-${id}`;
};
const IconTooltip = ({
  className,
  tooltipClassName,
  tip,
  icon,
  size = 'md',
  color = colors.primary,
  iconProps = {},
  place,
}) => {
  const tooltipId = useTooltipId();
  const { width = 16, height = 16 } = iconProps;

  const renderIcon = () => {
    if (typeof icon === 'string' || !icon) {
      return <TTIcon name={icon || 'info'} color={color} size={size} />;
    }

    return React.createElement(icon || TTIcon, {
      color,
      size,
      width,
      height,
      ...iconProps,
    });
  };

  return (
    <>
      <div
        data-tooltip-id={tooltipId}
        className={cx(styles.icon, className, {
          [styles.spaced]: !icon,
        })}
      >
        {renderIcon()}
      </div>
      <Tooltip
        id={tooltipId}
        place={place}
        className={cx(styles.tooltip, tooltipClassName)}
      >
        {tip}
      </Tooltip>
    </>
  );
};
IconTooltip.propTypes = {
  className: PropTypes.string,
  tooltipClassName: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.object,
    PropTypes.string,
  ]),
  tip: PropTypes.node,
  place: PropTypes.string,
  iconProps: PropTypes.object,
  size: PropTypes.string,
  color: PropTypes.string,
};
export default IconTooltip;
